module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "acknow"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_ix"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "pag_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once again, my heartfelt thanks go out to all the folks who help turn my words into a book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks go to my agent, Annelise Robey, and editors, Adam Wilson and Lauren McKenna, for all their helpful advice, support, and encouragement. Thanks also to Julia Fincher.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Tony Mauro for designing another terrific cover, and thanks to Louise Burke, Lisa Litwack, and everyone else at Pocket Books and Simon & Schuster for their work on the cover, the book, and the series.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And finally, a big thanks to all the readers. Knowing that folks read and enjoy my books is truly humbling, and I’m glad that you are all enjoying Gin and her adventures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I appreciate you all more than you will ever know.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pag_ix"
    }
  }, [_vm._v("Happy reading!")]), _c('a', {
    attrs: {
      "id": "pag_x"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pag_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d17e922","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknow.vue
// module id = 72
// module chunks = 0